<template>

	<div class="mt-4 mb-4 ss-payment">
		<transition name="list">
			<div class="row" v-show="intro === true">
				<div class="col-md-4 offset-md-4">
					<div class="intro-wrapper">
						
						<div class="ss-title" v-html="$parseHtml(replaceTokens(selectedPlan.wrapUp.title))"></div>
						<div class="ss-items" v-for="(item, i) in selectedPlan.wrapUp.intro" :key="i" v-html="$parseHtml(replaceTokens(item))"></div>
						
						<div class="text-center">
							<button class="mt-4 btn btn-lg btn-primary" style="width: 300px" @click.prevent="intro = false">CONTINUE</button>
							<router-link :to="{ name: 'profile' }" tag="a" class="text-primary mt-4 d-block">Go Back</router-link>
						</div>
						
					</div>

				</div>
			</div>
		</transition>
		<transition name="list">
			<div class="row" v-show="intro === false && paymentReady === false">

				<div class="col-md-4 offset-md-4 mb-2 mt-4">
					<div style="max-width: 400px; margin: auto">
						<div class="text-center">
							<div class="ss-confirms" v-for="(item, i) in findConfirmText" :key="i" v-html="$parseHtml(replaceTokens(item))"></div>
						</div>

						<div class="text-right" style="color: #cc6600">
							<i class="fa fa-lock"></i> Secure Server
						</div>

						<div class="payment-selector" @click="payment.method = 'ach'; paymentReady = true">
							<div class="text">ACH checking or savings</div> <div class="icons"><icon-check /></div>
						</div>
						<div class="payment-selector" @click="payment.method = 'card'; paymentReady = true;">
							<div class="text">Credit or debit card</div> <div class="icons"><icon-visa /><icon-mastercard /><icon-amex /><icon-discover /><icon-diners /></div>
						</div>

					</div>
					
					<div class="text-center">
						<router-link :to="{ name: 'profile' }" tag="a" class="text-primary mt-4 d-block">Go Back</router-link>
					</div>







				</div>

				

			</div>
		</transition>
		<transition name="list">
			<div class="row" v-show="paymentReady">

				<div class="col-md-12 mb-2 mt-4" v-loading="thinking.save" v-if="payment.method === 'card'">
					
					<div class="text-center d-block">
						<a class="text-primary" style="cursor: pointer" @click="payment.method = 'ach'">Use Bank Account</a>
					</div>

					<div class="cwrapper">


						<CardForm :form-data="payment"
											v-loading="thinking.save"
											:server-error="serverError"
											@valid="submitForm"
											@invalid="serverError = $event"
											@input-card-firstname="updateFirstName"
											@input-card-lastname="updateLastName"
											@input-card-number="updateCardNumber"
											@input-card-name="updateCardName"
											@input-card-month="updateCardMonth"
											@input-card-year="updateCardYear"
											@input-card-cvv="updateCardCvv"
											@input-card-zip="updateCardZip" />


					</div>


					<div class="text-center">
						<a class="text-primary" style="cursor: pointer" @click="paymentReady = false">Go back</a>
					</div>



				</div>

				<div v-else class="col-md-12 mb-2 mt-4" v-loading="thinking.save">

					<div class="text-center d-block">
						<a class="text-primary" style="cursor: pointer" @click="payment.method = 'card'">Use credit card instead</a>
					</div>
					
					<div class="cwrapper">
						<ACHForm :form-data="payment"
										 v-loading="thinking.save"
										 :selected-plan="selectedPlan"
										 @valid="submitForm"
										 @invalid="serverError = $event"
										 :server-error="serverError"
										 @input-bank-name="updateBankName"
										 @input-routing-number="updateRoutingNumber"
										 @input-account-number="updateAccountNumber" />


					</div>


					<div class="text-center">
						<a class="text-primary" style="cursor: pointer" @click="paymentReady = false">Go back</a>
					</div>
				</div>

				
				
			</div>
		</transition>

		

	</div>

	




</template>

<script>
	
	import { mapGetters } from "vuex";
	import { rest } from "@/utilities/rest.js";
	import CardForm from "@/components/payment/components/CardForm.vue";
	import ACHForm from "@/components/payment-ach/components/CardForm.vue";
	import amex from "@/components/icons/amex.vue";
	import diners from "@/components/icons/diners.vue";
	import mastercard from "@/components/icons/mastercard.vue";
	import visa from "@/components/icons/visa.vue";
	import discover from "@/components/icons/discover.vue";
	import check from "@/components/icons/check.vue";

	export default {
		name: "payment",
		components: {
			[amex.name]: amex,
			[diners.name]: diners,
			[mastercard.name]: mastercard,
			[visa.name]: visa,
			[discover.name]: discover,
			[check.name]: check,
			CardForm,
			ACHForm
		},
		data() {
			return {
				intro: true,
				thinking: {
					save: false
				},

				serverError: null,

				paymentReady: false,
								
				formData: {
					method: 'card',

					firstname: '',
					lastname: '',
					cardName: '',
					cardNumber: '',
					cardMonth: '',
					cardYear: '',
					cardCvv: '',
					cardZip: '',

					bankName: '',
					accountType: '',
					routingNumber: '',
					accountNumber: ''
				}

												
			}
		},

		created() {
			
			if (!this.selectedPlan) {
				this.$router.push({ name: "select-membership" });
			}
		},

		computed: {
			...mapGetters({
				selectedStudio: "selectedStudio",
				selectedPlan: "selectedPlan",
				locations: "locations",
				plans: "plans",
				profile: "profile",
				payment: "payment",
				stepsWatch: "stepsWatch"
			}),

			findConfirmText() {
				let txt = _.find(this.plans.plans, { id: this.selectedPlan.id });
				return txt.confirm;
			},

			trialEnds() {
				var date = new Date();
				date.setMonth(date.getMonth() + 1)
				var dd = String(date.getDate()).padStart(2, '0');
				var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy = date.getFullYear();
				date = mm + '/' + dd + '/' + yyyy;
				return date;
			}
			

			
		},

		methods: {

			replaceTokens(str) {
				let retVal = null;
				try {
					retVal = str.replace('{{firstname}}', this.profile.firstname)
					//.replace('{{studio}}', this.selectedStudio.title)
					.replace('{{plan}}', this.selectedPlan.title.replace('<br>', ' '))
					.replace('{{price}}', this.selectedPlan.price)
					.replace('{{dropin}}', this.selectedPlan.dropin)
					.replace('{{trialenddate}}', this.trialEnds)
					.replace('{{access}}', this.selectedPlan.access)
					.replace('{{numclass}}', this.selectedPlan.numclass)
					.replace('{{workshop}}', this.selectedPlan.workshop)
					.replace('{{resend}}', this.selectedPlan.resend);
				} catch(err) {
					return "an error occurred evaluating tokens"
				}
				return retVal;
				
			},
			updateCardNumber (val) {
			},
			updateCardName (val) {
			},
			updateCardMonth (val) {
			},
			updateCardYear (val) {
			},
			updateCardCvv (val) {
			},
			updateCardZip(val) {
			},
			updateBankName(val) {
			},
			updateRoutingNumber(val) {
			},
			updateAccountNumber(val) {
			},
			updateFirstName(val) {
			},
			updateLastName(val) { },


			submitForm() {

				
				this.$validator.validateAll().then(result => {
					
					if (result) {
						this.serverError = null;
						this.thinking.save = true;
						// clone our payload
						var formData = JSON.parse(JSON.stringify(this.profile));
						formData.studioId = null; //this.selectedStudio.id;
						formData.planId = this.selectedPlan.id;
						formData.payment = this.payment;
						formData.referredBy = this.$store.state.referredBy;
						rest.post("Signup/", "CompleteOrder", "json", JSON.stringify(formData)).done(response => {

							try {
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({ 'event': 'free Trial' });
							} catch (err) {
								console.log("gt error: ", err);
							}

							this.$router.push({ name: "finished" });							
						}).fail((xhr) => {
							console.log(xhr);
							if (xhr && xhr.status === 0) {
								this.serverError = "We're having difficulty processing your request. Please check your internet connection.";
							} else if (xhr.status === 500 && xhr.responseText) {
								this.serverError = JSON.parse(xhr.responseText).Message;
							} else {
								this.serverError = "An unknown error occurred while trying to validate your payment.";
							}
						}).always(() => {
							this.thinking.save = false;
						});
						
					}
				})
			}

			
			
		},

		watch: {
			
		}
	}
</script>

<style scoped>

	.payment-selector {
		border: 1px solid #ccc;
    border-radius: 2px;
    cursor: pointer;
		position: relative;
		height: 50px;
		transition: all 0.3s;
		margin-bottom: 5px;
	}
	.payment-selector:hover {
		background: rgba(0, 0, 0, .05);
	}
	.payment-selector .text {
		font-size: 14px;
		position: absolute;
		left: 8px;
		top: 12px;
	}
	.payment-selector .icons {
		position: absolute;
    right: 8px;
    top: 12px;
	}
	.intro-wrapper {
		max-width: 400px;
		margin: auto;
	}
	.checks {
		
		max-width: 400px;
		margin: auto;		
		
	}

	svg {
		width: 25px;
		position: relative;
		top: -12px
	}

	.check {
		position: relative;
		font-size: 18px;
	}
	.check p {
		font-size: 16px;
		margin-bottom: 15px;
		color: #333;
	}

		.check i {
			position: relative;
			right: -5px;
			top: 5px;			
		}

		.list-enter,
	.list-leave-to {
		visibility: hidden;
		height: 0;
		margin: 0;
		padding: 0;
		opacity: 0;
	}

	.list-enter-active,
	.list-leave-active {
		transition: all 0.3s;
	}
</style>

